import { css, mediaQueries } from '@eti/styles';
import { Button, Dialog } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { X as CloseIcon } from '@phosphor-icons/react';
import { jsx as _jsx } from "react/jsx-runtime";
const seatMapDialogStyles = css`
  background: #fff;
  border-radius: 0.1875rem;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  height: inherit;
  max-height: 100%;
  outline: none;
  position: absolute;

  @media ${mediaQueries.medium.up} {
    height: 90vh;
    inset: 20px;
    margin: auto;
    max-width: 48rem;
  }

  @media ${mediaQueries.large.up} {
    max-width: 1200px;
  }

  @media (min-width: 1200px) {
    width: 1200px;
  }
`;
const SeatMapDialog = _ref => {
  let {
    show,
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Dialog, {
    className: seatMapDialogStyles,
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": "seatMap-dialog",
    isOpen: show,
    title: "Select seats" // To be replaced with a text key
    ,
    children: /*#__PURE__*/_jsx(Button, {
      "data-testid": "seatMap-closeIcon-button",
      onClick: onClose,
      type: "button",
      children: /*#__PURE__*/_jsx(CloseIcon, {
        alt: "close",
        size: 25
      })
    })
  });
};
export default SeatMapDialog;
//# sourceMappingURL=SeatMapDialog.js.map